import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';
import { MinMaxStep, WorkoutSectionMinMaxStepByMode } from '../../types/section.type';

/**
 * Bornes de l'axe (vertical) du graphe par mode.
 * `incSpd` : non utilise, chaque champ prend ses bornes dans `MULTI_FIELD_WORKOUT_SECTION_MIN_MAX_STEP`.
 */
export const DEFAULT_WORKOUT_SECTION_MIN_MAX_STEP: {
  readonly [M in WorkoutMode]: Readonly<WorkoutSectionMinMaxStepByMode[M]>;
} = {
  ftp: { min: 0, max: 140, step: 5 },
  watts: { min: 0, max: 2000, step: 10 },
  res: { min: 0, max: 100, step: 1 },
  slope: { min: 0, max: 15, step: 1 },
  inc: { min: 0, max: 15, step: 1 },
  spd: { min: 1, max: 25, step: 0.5 },
  incSpd: { min: 0, max: 100, step: 1 },
};

/**
 * Bornes de chaque champ des modes a plusieurs valeurs, par type de champ.
 * Les deux axes partagent le nombre de ticks du mode (`WORKOUT_MODE_TICKS_COUNT`) :
 * choisir des bornes qui tombent rond sur ce decoupage.
 * Un champ absent prend les bornes de son propre mode (`DEFAULT_WORKOUT_SECTION_MIN_MAX_STEP`).
 */
export const MULTI_FIELD_WORKOUT_SECTION_MIN_MAX_STEP: Readonly<
  Partial<Record<WorkoutMode, Readonly<Partial<Record<WorkoutMode, Readonly<MinMaxStep>>>>>>
> = {
  incSpd: {
    inc: { min: 0, max: 20, step: 1 },
    spd: { min: 0, max: 25, step: 0.5 },
  },
};
